export default function getCakeDeFiWebAppBaseURL() {
  return process?.env?.PUBLIC_URL || 'https://app.bake.io';
}
